import {Alert, Button, Card, CardBody, Col, Form, FormGroup, Input, Spinner,} from "reactstrap";
import React, {useEffect, useState} from "react";
import {Link, useHistory} from "react-router-dom";

import "firebase/app";
import {getAuth, sendPasswordResetEmail, signInWithEmailAndPassword} from "firebase/auth";
import {initializeApp} from "firebase/app";
import {firebaseConstants, getDb} from "../../util/Constants";
import {collection, getDocs, query, where} from "firebase/firestore";
import youtube from "../../assets/img/icons/user/youtube.png";
import facebook from "../../assets/img/icons/user/facebook.png";
import linkedin from "../../assets/img/icons/user/linkedin.png";
import Swal from "sweetalert2";
import {NotificationManager} from "react-notifications";

const app = initializeApp(firebaseConstants.firebaseConfig);
const auth = getAuth();

const Login = (props) => {
    let history = useHistory();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [forgetPassword, setForgetPassword] = useState(false);

    useEffect(() => {
        console.log(props.metadata);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(undefined);
        setLoading(true);
        try {
            const q = query(collection(getDb(), "admins"), where("email", "==", email));
            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                // User does not exist
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'User not exists.',
                })
                setLoading(false)
            } else {
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (!data.active && data.role !== "superAdmin") {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Permission revoked by SuperAdmin.',
                        })
                        setLoading(false);

                    } else {
                        signInWithEmailAndPassword(auth, email, password)
                            .then((userCredential) => {
                          
                               
                                if (userCredential.user.email === "super.admin@activ8games.com" || userCredential.user.email === "usama@gmail.com") {

                                } else if (!userCredential.user.emailVerified) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Account not verified',
                                        text: 'Please verify your email.',
                                    });
                                    setLoading(false);
                                }
                              
                              

                                // if (!userCredential.user.emailVerified || (userCredential.user.email !== "super.admin@activ8games.com" ||
                                //     userCredential.user.email !== "usama@gmail.com")) {
                                //     setLoading(false);
                                //     Swal.fire({
                                //         icon: 'error',
                                //         title: 'Account not verified',
                                //         text: 'Please verify your email.',
                                //     })
                                // }

                            })
                            .catch((error) => {
                                setLoading(false);

                                if (
                                    error.message === "Firebase: Error (auth/user-not-found)." ||
                                    error.message === "Firebase: Error (auth/wrong-password)."
                                ) {
                                    setError("Invalid username or password");
                                } else {
                                    setError(error.message);
                                }

                                setTimeout(() => {
                                    setError(undefined);
                                }, 5000);
                            });
                    }
                });
            }

        } catch (error) {

        }
    };
    const resetPassword = async () => {
        setLoading(true);
        console.log(email);
        sendPasswordResetEmail(auth, email).then(() => {
            NotificationManager.success("Reset email sent");
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            const errorCode = error.code;
            console.log(errorCode)
            const errorMessage = error.message
            console.log(errorMessage)
            NotificationManager.error("Invalid email, Please use valid e-mail address");
            setLoading(false);
        })
    }

    return (
        <>
            <Col lg="8" md="10">
                <Card className="br-15">
                    <CardBody className="startCard">
                        <div className="text-center mb-5 custom-font">
                            <label className="font-weight-600 display-4 text-dark">Gateway to
                                your {props.metadata.environment === "progress" ? "Learning " : "Assessment "}
                                Platform</label>
                        </div>
                        {error && <Alert color="danger">{error}</Alert>}
                        <Form role="form" onSubmit={handleSubmit}>
                            <FormGroup className="mb-3">
                                {/*<FormLabel className="small font-weight-bold text-dark ml-3">Name</FormLabel>*/}
                                <Input
                                    placeholder="Email"
                                    className="assessment-input"
                                    type="email"
                                    autoComplete="new-email"
                                    value={email}
                                    required
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <label className="fs-14 ml-2 font-weight-600">Email</label>
                            </FormGroup>
                            {!forgetPassword &&
                                <FormGroup>
                                    {/*<FormLabel className="small font-weight-bold text-dark ml-3">Password</FormLabel>*/}
                                    <Input
                                        placeholder="Password"
                                        type="password"
                                        className="assessment-input"
                                        //autoComplete="new-password"
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <label className="fs-14 ml-2 font-weight-600">Password</label>
                                </FormGroup>
                            }
                            <div className="text-center my-4">
                                {forgetPassword ?
                                    <Button
                                        className="footerButton text-white mb-2"
                                        color=""
                                        type="button"
                                        onClick={resetPassword}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <Spinner color="white" size="sm" className="mx-3">
                                                Loading..
                                            </Spinner>
                                        ) : (
                                            "Reset Password"
                                        )}
                                    </Button> :
                                    <Button
                                        className="footerButton text-white mb-2"
                                        color=""
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <Spinner color="white" size="sm" className="mx-3">
                                                Loading..
                                            </Spinner>
                                        ) : (
                                            "Login"
                                        )}
                                    </Button>
                                }
                                {/*<Button*/}
                                {/*    className="footerButton text-white mb-2"*/}
                                {/*    color=""*/}
                                {/*    type="submit"*/}
                                {/*    disabled={loading}*/}
                                {/*>*/}
                                {/*    {loading ? (*/}
                                {/*        <Spinner color="white" size="sm" className="mx-3">*/}
                                {/*            Loading..*/}
                                {/*        </Spinner>*/}
                                {/*    ) : (*/}
                                {/*        "Login"*/}
                                {/*    )}*/}
                                {/*</Button>*/}
                                <div>
                                    <span>Don’t have an account with us? <Link to="/auth/register?plan=free"
                                                                               className="text-underline">Sign&nbsp;up!</Link></span>
                                </div>
                                {forgetPassword ?
                                    <div>
                                    <span className="text-underline text-blue" onClick={() => {
                                        setForgetPassword(false)
                                    }} role="button">
                                        Click to login
                                    </span>
                                    </div> :
                                    <div>
                                    <span className="text-underline text-blue" onClick={() => {
                                        setForgetPassword(true)
                                    }} role="button">
                                        Forgot your password?
                                    </span>
                                    </div>
                                }
                            </div>
                            <div className="text-center">
                                <label className="font-weight-bold">Connect with Us</label>
                                <div className="">
                                    <a href="https://www.youtube.com/@activ8games" target="_blank">
                                        <img src={youtube}/>
                                    </a>
                                    <a href="https://www.linkedin.com/company/activ8games/" target="_blank">
                                        <img src={linkedin} className="mx-2"/>
                                    </a>
                                    <a href="https://www.facebook.com/Activ8Games/" target="_blank">
                                        <img src={facebook}/>
                                    </a>
                                </div>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
            </Col>
        </>
    );
};

export default Login;
